import styled from 'styled-components';
import {
  colors,
  ApButtonMain,
  ApButtonSecondary,
} from '@alixpartners/ui-components';

export const PageContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 24px;
  background-color: #f1f1f1;
  min-height: 100%;
  box-sizing: border-box;
`;

export const HeroCard = styled.div<{ bgImage: string }>`
  background-color: #878787;
  background-image: url(${({ bgImage }) => bgImage});
  background-size: cover;
  background-position: center;
  border-radius: 8px;
  padding: 24px 200px 24px 24px;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const HeroIllustration = styled.img`
  position: absolute;
  top: 12px;
  right: 0;
  width: 160px;
  height: 160px;
  overflow: hidden;
`;

export const HeroTextContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const HeroTitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 19px;
  line-height: 27px;
  color: ${colors.white};
`;

export const HeroDescription = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: ${colors.white};
`;

export const KeyBenefitsGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const KeyBenefitsLabel = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: ${colors.white};
`;

export const PillsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  align-items: flex-start;
`;

export const InfoPill = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 8px;
  border: 1px solid #b0deeb;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: ${colors.white};
  white-space: nowrap;
`;

export const Card = styled.div`
  background-color: ${colors.white};
  border: 1px solid #e4e4e4;
  border-radius: 8px;
  padding: 24px;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
`;

export const CardTitleGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const CardHeading = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 17px;
  line-height: normal;
  color: #000000;
`;

export const CardSubtitle = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: rgba(0, 0, 0, 0.87);
`;

export const CardSubtitleSm = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  line-height: 18px;
  color: rgba(0, 0, 0, 0.87);
`;

export const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: 8px;
`;

export const AddFilesButton = styled(ApButtonMain)`
  && span {
    font-size: 15px;
    letter-spacing: 0.3px;
  }
`;

export const UpdateReportsButton = styled(ApButtonSecondary)`
  && span {
    font-size: 15px;
    letter-spacing: 0.3px;
  }
`;

export const TableWrapper = styled.div`
  border: 1px solid #e4e4e4;
  margin-top: 16px;
  overflow-x: auto;
`;

export const TableHeaderRow = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
  padding: 8px 16px;
  background-color: ${colors.white};
`;

export const TableHeaderCellFileName = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #737373;
  flex: 1;
  min-width: 0;
  white-space: nowrap;
`;

export const TableHeaderCell = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #737373;
  white-space: nowrap;
`;

export const TableHeaderCellType = styled(TableHeaderCell)`
  width: 213px;
  flex-shrink: 0;
`;

export const TableHeaderCellCreatedBy = styled(TableHeaderCell)`
  width: 213px;
  flex-shrink: 0;
`;

export const TableHeaderCellCreatedOn = styled(TableHeaderCell)`
  width: 213px;
  flex-shrink: 0;
`;

export const TableHeaderCellActions = styled(TableHeaderCell)`
  margin-left: auto;
`;

export const TableDataRow = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
  padding: 16px;
  background-color: ${colors.white};
  box-shadow: 0px -1px 0px #cccccc;
`;

export const TableRowContent = styled.div`
  display: flex;
  flex: 1;
  gap: 32px;
  align-items: center;
`;

export const FileNameCell = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  flex: 1;
  min-width: 0;
  overflow: hidden;
`;

export const FileIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 34px;
  background-color: #f1f1f1;
  border-radius: 4px;
  flex-shrink: 0;
`;

export const TableCellText = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #4a4a4a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const TableCellType = styled(TableCellText)`
  width: 213px;
  flex-shrink: 0;
`;

export const TableCellCreatedBy = styled(TableCellText)`
  width: 213px;
  flex-shrink: 0;
`;

export const TableCellCreatedOn = styled(TableCellText)`
  width: 213px;
  flex-shrink: 0;
`;

export const TableActionsCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;

export const AiBanner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background-color: #faf6fe;
  border: 1px solid #d3adf7;
  border-radius: 8px;
  padding: 12px;
`;

export const AiBannerHeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  cursor: pointer;
`;

export const AiBannerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
`;

export const AiBannerIcon = styled.img`
  width: 20px;
  height: 20px;
  flex-shrink: 0;
`;

export const AiBannerText = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #632494;
`;

export const AiBannerTextStrong = styled.span`
  font-weight: 500;
`;

export const AiBannerChevron = styled.div<{ isExpanded?: boolean }>`
  flex-shrink: 0;
  display: flex;
  align-items: center;
  transform: ${({ isExpanded }) => (isExpanded ? 'rotate(180deg)' : 'none')};
  transition: transform 0.2s ease;
`;

export const TableLoadingRow = styled.div`
  padding: 16px;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.87);
  background-color: ${colors.white};
  box-shadow: 0px -1px 0px #cccccc;
`;

export const TableEmptyRow = styled(TableLoadingRow)``;

export const AiBannerTable = styled.div`
  overflow-x: auto;
`;

export const AiBannerTableHeaderRow = styled.div`
  display: flex;
  gap: 24px;
  padding: 0 76px 0 16px;
  align-items: center;
  margin-bottom: 4px;
`;

const AiBannerTableHeaderCellBase = styled.div`
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  color: #4a4a4a;
  white-space: nowrap;
  display: flex;
  align-items: center;
  gap: 2px;

  .material-icons-outlined {
    font-size: 16px;
  }
`;

export const AiBannerTableHeaderCellTitle = styled(AiBannerTableHeaderCellBase)`
  width: 320px;
  flex-shrink: 0;
`;

export const AiBannerTableHeaderCellDimensions = styled(
  AiBannerTableHeaderCellBase
)`
  flex: 1;
`;

export const AiBannerTableHeaderCellDate = styled(AiBannerTableHeaderCellBase)`
  width: 240px;
  flex-shrink: 0;
`;

export const AiBannerTableHeaderCellAction = styled(
  AiBannerTableHeaderCellBase
)`
  width: 120px;
  flex-shrink: 0;
`;

export const AiBannerTableDataRow = styled.div`
  display: flex;
  gap: 24px;
  padding: 8px 76px 8px 16px;
  background-color: #ffffff;
  border-radius: 2px;
  align-items: center;
  margin-bottom: 4px;
`;

export const AiBannerTableCellTitle = styled.div`
  width: 320px;
  flex-shrink: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 13px;
  line-height: 16px;
  color: #4a4a4a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AiBannerTableCellText = styled.div`
  flex: 1;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #1a1a1a;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AiBannerTableCellDate = styled.div`
  width: 240px;
  flex-shrink: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #1a1a1a;
`;

export const AiBannerTableActionsCell = styled.div`
  width: 120px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 24px;
`;

export const AiBannerActionButton = styled.button`
  display: flex;
  align-items: center;
  gap: 2px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-family: 'Roboto', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.24px;
  color: #4a4a4a;
  white-space: nowrap;

  .material-icons-outlined {
    font-size: 20px;
  }
`;

export const AiBannerDeleteButton = styled(AiBannerActionButton)`
  color: #cb282e;
`;

export const RowIconButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
`;
